import React, { useEffect, useState, useRef } from 'react';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import { inHomeWhereErrors } from '../../constants/textConstants';
import InHomeConfirmationModal from './InHomeConfirmationModal';
import { Typography, Modal, DropDownWithValidation as DropDown } from "../ecosystem/";
import { InHomeMainPanel, InHomeOverviewPanel, InHomePatientInputSection, InHomeSplitLayout } from "./layout"

import * as msgs from "../../constants/textConstants";

const InHomeInsurance = ({ serviceLocation, history, selectedUsers, insuranceOptions, getAvailableVaccines, setSelectedUsers, setSelectedVaccines, screenBreakPoint }) => {

    const [showWarning, setShowWarning] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [elegibleModalOptions, setElegibleModalOptions] = useState({
        showModal: false,
        modalHeader: '',
        modalBody: '',
        modalButtons: {},
        showButtonX: false
    });


    useEffect(() => {
        logUI(`MBHWeb.UI.InHomeSchedulingInsurance.Displayed`, new Date(), Tools.getURLPath());
    }, []);


    const isNextButtonDisabled = () => {
        return selectedUsers && !selectedUsers.every((user) => user.insurance && user.insurance !== "");
    }

    const continueToNextStep = () => {
        getAvailableVaccines();
        history.push("/inhomeschedule/s4")
    }

    const onClickNext = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingInsurance.Next.Clicked`, new Date(), Tools.getURLPath());
        if (!isNextButtonDisabled()) {
            let notEligibleUsers = selectedUsers.filter(usr => usr.insurance === 'Self-Pay' || usr.insurance === 'Medicaid')
            let count = notEligibleUsers.length;
            if (count === 0)
                continueToNextStep()
            else {
                let notEligibleUsersNames = ''
                elegibleModalOptions.modalHeader = ''
                elegibleModalOptions.modalBody = ''
                elegibleModalOptions.showButtonX = false

                notEligibleUsersNames = notEligibleUsers.map(usr => usr.firstName).join(`${count > 2 ? ',' : ' &'} `)
                let buttons = [{ label: "Cancel", onClick: () => { closeElegibleModal(false) } }, { label: "Continue to dashboard", onClick: cancelBooking }]

                if (selectedUsers.length === count && count > 1) {
                    elegibleModalOptions.modalHeader = 'There are no recipients eligible for vaccines at home.'
                    elegibleModalOptions.modalBody = 'Contact your doctor for additional vaccine options.'

                }
                else
                    if (selectedUsers.length === 1 && count > 0) {
                        elegibleModalOptions.modalHeader = `${notEligibleUsersNames} does not quality for vaccines at home.`
                        elegibleModalOptions.modalBody = `Contact ${notEligibleUsersNames}'s doctor for additional vaccine options.`
                    }
                    else {
                        //Header Text
                        const lastIndex = notEligibleUsersNames.lastIndexOf(', ');
                        if (lastIndex > 0)
                            notEligibleUsersNames = notEligibleUsersNames.slice(0, lastIndex) + ' and' + notEligibleUsersNames.slice(lastIndex + 1);
                        elegibleModalOptions.modalHeader = `${notEligibleUsersNames} ${count === 1 ? 'is' : 'are'} not eligible for vaccines at home.`

                        //Body Text
                        elegibleModalOptions.modalBody = <span>Contact {notEligibleUsersNames}'s doctor{count === 1 ? '' : 's'} for additional vaccine options.
                            <br /><br />You can continue booking and {count === 1 ? 'this recipient' : 'these recipients'} will be removed from the request.</span>

                        //Buttons Text
                        buttons = [{ label: "Cancel booking", onClick: cancelBooking }, { label: "Continue", onClick: () => { closeElegibleModal(true) } }]
                        elegibleModalOptions.showButtonX = true
                    }
                elegibleModalOptions.modalButtons = buttons
                elegibleModalOptions.showModal = true;
                setElegibleModalOptions({ ...elegibleModalOptions });
            }
        } else {
            setShowWarning(true);
        }
    }

    const onClickPrev = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingInsurance.Previous.Clicked`, new Date(), Tools.getURLPath());
        history.push("/inhomeschedule/s3")
    }


    const handleInputChange = (event, userIndex) => {
        let tempUsers = [...selectedUsers];
        tempUsers.forEach((tempUser, index) => {
            if (index === userIndex) {
                tempUser.insurance = event.target.value;
            }
        })
        setSelectedUsers([...tempUsers]);
    }

    const closeModal = () => {
        setShowModal(false);
    }
    const closeElegibleModal = (removeNotElegible) => {
        if (removeNotElegible) {
            setSelectedUsers(selectedUsers.filter(usr => usr.insurance !== 'Self-Pay' && usr.insurance !== 'Medicaid'))
            continueToNextStep()
        }
        setElegibleModalOptions({ ...elegibleModalOptions, showModal: false });
    }
    const cancelBooking = () => {
        setShowModal(false);
        setElegibleModalOptions({ ...elegibleModalOptions, showModal: false });
        history.push("/")
    }
    const handlePopup = () => {
        setShowModal(!showModal)
    }
    const isMobileSize = (screenBreakPoint === msgs.XS_MOBILE || screenBreakPoint === msgs.SM_MOBILE || screenBreakPoint === msgs.MD_TABLET || screenBreakPoint === msgs.LG_TABLET || screenBreakPoint === msgs.XL_DESKTOP) ? true : false;
    return (
        <>
            {(!selectedUsers || selectedUsers?.length < 1) ? <Redirect to='/inhomeschedule/s3' /> :
                <>
                    <InHomeSplitLayout
                        className="inhome-scheduling-insurance-container"
                        progressPercent={3 / 7 * 100}
                    >
                        <InHomeMainPanel
                            heading="Select your primary insurance coverage"
                            subheading="Self-pay and Medicaid patients are not currently eligible for an in-home vaccine appointments at this time."
                            schedulingButtons={{
                                disabledNext: isNextButtonDisabled(),
                                leftOnClick: onClickPrev,
                                rightOnClick: onClickNext
                            }}
                        >
                            <div className="row">
                                <div className="col-12 col-lg-10 insurance-selection-div">
                                    {selectedUsers && selectedUsers.map((user, userIndex) => {
                                        return (
                                            <InHomePatientInputSection
                                                key={`user-${userIndex}`}
                                                patientName={`${user.patientName} (${user.dob})`}
                                            >
                                                <DropDown
                                                    label="Select primary coverage"
                                                    id="insurance"
                                                    name="insurance"
                                                    value={user.insurance || ""}
                                                    onChange={(e) => handleInputChange(e, userIndex)}
                                                    options={insuranceOptions}
                                                    required
                                                    errorMsg="Select a valid primary coverage"
                                                />
                                            </InHomePatientInputSection>
                                        );
                                    })}
                                </div>
                            </div>                            
                        </InHomeMainPanel>

                        <InHomeConfirmationModal />

                        {
                            showModal && <>
                                <Modal
                                    isOpen={showModal}
                                    //onCloseClick={closeModal}
                                    //className="inhome-modal"
                                    modalHeader={<>
                                        {getVaccineResult.errorMsg === inHomeWhereErrors.noVax ?
                                            "There are no vaccine appointments available at this time." :
                                            getVaccineResult.errorMsg === inHomeWhereErrors.notInServiceArea ?
                                                "In-home vaccinations are not available in this area." :
                                                getVaccineResult.errorMsg === inHomeWhereErrors.notValidZip ?
                                                    "Incorrect ZIP Code"
                                                    :
                                                    "Oops, something went wrong."
                                        }
                                    </>}
                                    modalBody={<>
                                        {getVaccineResult.errorMsg === inHomeWhereErrors.noVax ?
                                            "You can change your location or come back later and try again." :
                                            getVaccineResult.errorMsg === inHomeWhereErrors.notInServiceArea ?
                                                "You can try a different zip code or check back again later. We’ll be expanding our service area soon." :
                                                getVaccineResult.errorMsg === inHomeWhereErrors.notValidZip ?
                                                    `The ZIP code you entered is not valid for ${locationInfo.city.toUpperCase()}. Please try again.`
                                                    :
                                                    "Please try again later if the issue persists." || `${getVaccineResult?.errorMsg}`
                                        }
                                    </>}
                                    modalFooterButtons={
                                        getVaccineResult.errorMsg === inHomeWhereErrors.noVax || getVaccineResult.errorMsg === inHomeWhereErrors.notInServiceArea ?
                                            [{ label: "Update location", onClick: closeModal },
                                            { label: "Cancel booking", onClick: cancelBooking }]
                                            :
                                            [{ label: getVaccineResult.errorMsg === inHomeWhereErrors.notValidZip ? 'Try again' : 'Okay', onClick: closeModal }]
                                    }
                                />
                            </>

                        }
                        {
                            <Modal isOpen={elegibleModalOptions.showModal}
                                alignText="left"
                                alignFooter="right"
                                modalHeader={elegibleModalOptions.modalHeader}
                                modalBody={elegibleModalOptions.modalBody}
                                modalFooterButtons={elegibleModalOptions.modalButtons}
                                onCloseClick={elegibleModalOptions.showButtonX && closeElegibleModal}
                            />
                        }

                        <InHomeOverviewPanel insurancePhase={true} />
                    </InHomeSplitLayout>
                </>
            }</>
    );
}
const mapStateToProps = state => {
    const selectedUsers = state.inHome.selectedUsers;


    return {
        serviceLocation: state.inHome.serviceLocationContactInfo,
        selectedUsers: state.inHome.selectedUsers,
        screenBreakPoint: state.common.screenBreakPoint,
        insuranceOptions: state.inHome.prefilledData?.insurance_types,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setSelectedUsers: (users) => { dispatch({ type: types.SET_SELECTED_USERS, selectedUsers: users }) },
        getAvailableVaccines: () => { dispatch({ type: types.GET_INHOME_VACCINES }) },
        setSelectedVaccines: (data) => { dispatch({ type: types.SET_INHOME_VACCINES, data }) },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InHomeInsurance);